import {AfterViewInit, Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {first} from 'rxjs/operators';
import {UserService} from '../../../../_services';
import {ToastService} from '../../../../_services/toast.service';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LoadingService} from '../../../../_services/loading.service';
import {Platform} from '@ionic/angular';
import {StorageService} from '../../../../_services/storage.service';
import {GuestUser, Roles} from '../../../../_model';
import {environment} from '../../../../../environments/environment';
import {CommonService} from '../../../../_services/common.service';
import {ModalController} from '@ionic/angular';
import {MenuOptionsModalPage} from '../../../../components/menu-options-modal/menu-options-modal-page';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
})
export class SignInComponent implements OnInit, AfterViewInit {
  signInForm: FormGroup;
  submitted = false;
  userRole: Roles;
  projectType: string;
  projectObj: any;
  projectTypeImage = '';
  guestUserObj: GuestUser = {};
  showPassword = false;
  showBackIcon = true;

  constructor(public toast: ToastService,
              public translate: TranslateService,
              public loadingService: LoadingService,
              private commonService: CommonService,
              // public profileService: SeekerProfileService,
              private activatedRoute: ActivatedRoute,
              private platform: Platform,
              public authService: UserService,
              private storageService: StorageService,
              public router: Router,
              public modalController: ModalController) {

    this.signInForm = new FormGroup({
      email: new FormControl('',
        [
          Validators.required,
          Validators.email
        ]),
      password: new FormControl('',
        [
          Validators.required
        ])
    });
    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.projectType = params.project;
      this.projectObj = this.commonService.getProjectDetails(params.projectType);
      if (this.projectType) {
        if (this.projectType === 'ic') {
          this.projectTypeImage = 'assets/img/logo/LOGO-IC.svg';
        } else if (this.projectType === 'yarn') {
          this.projectTypeImage = 'assets/img/logo/LOGO-YC.svg';
        } else if (this.projectType === 'paint') {
          this.projectTypeImage = 'assets/img/logo/LOGO-PR.svg';
        } else if (this.projectType === 'codeRed') {
          this.projectTypeImage = 'assets/img/logo/LOGO-CR.svg';
        } else {
          if (this.router.url === '/admin') {
            this.projectTypeImage = 'assets/img/logo/LOGO-ADMIN.svg';
          } else {
            this.projectTypeImage = 'assets/img/logo/LOGO-AP.svg';
          }
        }
      }
    });
  }

  ngOnInit() {
    this.guestUser();
    this.activatedRoute.paramMap.subscribe((params: any) => {
      this.projectType = params.get('project');
      [this.projectType, this.projectTypeImage] = this.commonService.getProjectLogo(this.projectType);
      if (this.router.url === '/admin') {
        this.projectTypeImage = 'assets/img/logo/LOGO-ADMIN.svg';
      }
    });
  }

  async guestUser() {
    this.guestUserObj = await this.storageService.get(environment.userObj);
    this.userRole = Roles[this.guestUserObj === null ? 'guest' : this.guestUserObj.role];
  }

  // convenience getter for easy access to form fields
  // eslint-disable-next-line @typescript-eslint/member-ordering
  get field(): any {
    return this.signInForm.controls;
  }

  onSubmit(): void {
    // saga({event: 'login', data: 'sri@whyable.com'});
    this.submitted = true;
    // show error if form is invalid
    if (this.signInForm.invalid) {
      return;
    }
    // this.spinner.show();
    this.loadingService.show();
    const user: any = this.signInForm.value;
    this.authService.login(user)
      .pipe(first())
      .subscribe(
        (data) => {
          this.loadingService.hide();
          this.loginSuccess(data);
        }, (error) => {
          console.error('error', error.message);
          this.loadingService.hide();
          if (error.message === 'Your email verification is Pending.') {
            this.toast.error('Email verification pending.');
          } else {
            this.toast.error('Incorrect Username or Password');
          }
          this.userRole = Roles[this.guestUserObj.role];
        });
  }

  loginSuccess(data): void {
    this.toast.display('Logged in successfully');
    if (data.user.hasOwnProperty('isAdmin') && data.user.isAdmin && this.router.url === '/admin') {
      this.router.navigate(['/admin/console']);
    } else {
      this.router.navigate(['/map']);
    }
  }

  navigateToForgotPassword() {
    this.router.navigate(['./user/auth/forgot-password']);
  }

  navigateToSignUp() {
    this.router.navigate(['./user/auth/sign-up']);
  }

  /*async openMenu() {
    const modal = await this.modalController.create({
      component: MenuOptionsModalPage,
      componentProps: {
        projectType: this.projectType
      },
      cssClass: 'custom-menu',
      showBackdrop: true,
      backdropDismiss: true,
      swipeToClose: true,
      breakpoints: [0, 0.5, 0.75, 1],
      initialBreakpoint: 0.5,
      handle: false
    });
    return await modal.present();
  }*/
  // eslint-disable-next-line @typescript-eslint/member-ordering
  isAdmin = false;

  togglePassword(event: boolean) {
    this.showPassword = event;
  }

  ngAfterViewInit(): void {
    if (this.router.url === '/admin') {
      this.showBackIcon = false;
      this.isAdmin = true;
    }
  }

}
